module.exports = __webpack_public_path__ + "img/belt-2.3d5dde47.png";